import { createSignal, createEffect } from "solid-js";

import {
  Checkbox,
  CheckboxControl,
} from "@/components/shadcn/checkbox";

export const ListItemCheckbox = (props) => {

  const [checked, setChecked] = createSignal(false);

  const onChange = (checked) => {
    props.onToggle(props.key, checked);
  }

  createEffect(() => {
    props.items;
    setChecked(props.items.includes(props.key));
  });

  createEffect(() => {
    props.key;
    setChecked(props.items.includes(props.key));
  });
  return (
    <Checkbox class="flex items-center" checked={checked()} onChange={(checked) => onChange(checked)}>
      <CheckboxControl class="border-gray-400 shadow-none me-2" />
    </Checkbox>
  );
}
